import React, { useState, useContext, useRef, useEffect } from 'react';

import PropTypes from 'prop-types';

import HeaderStroke from '../../HeaderStroke';

import { ContextSolicitacoes } from '../../../services/solicitacoes';

import { ContextoListaApartamentos } from '../../ApartamentList/contextoImoveis';
import { ContextSindico } from '../../../services/sindico';

import DadosSolicitacao from './DadosSolicitacao';

import ResumoAgendamento from './ResumoAgendamento';

import Buttons from './Buttons';

import EditarSolicitacao from './EditarSolicitacao';

import CancelarSolicitacao from './CancelarSolicitacao';

import EntendiConcordo from '../EntendiConcordo';

import { Spinner } from '../../StyledComponent';

import MsgSolicitacao from './MsgSolicitacao';

import uuid from 'react-uuid';

import { useParams } from 'react-router-dom';

import { MsgAvisoAssistenciaTecnica } from './styles';

import { getUrlFotoS3 } from '../../../services/endPointsNotificacoes';

const Title = ({ color }) => {
  const style = {
    color: color,
    paddingLeft: '16px',
    margin: '0, 0, 16px, 0,',
  };
  return <h2 style={style}>RESUMO DA SOLICITAÇÃO:</h2>;
};

const AcompanharSolicitacao = ({
  confirmarSolicitacao,
  tiposSolicitacaoComAgendamento,
  solicitacao,
  isSindico,
}) => {
  const { tema: temaPortal } = useContext(ContextoListaApartamentos);

  const {
    editAssistenciaTecnica,
    getSolicitacao,
    getAnexoSolicitacao,
    saveFiles,
    removeFiles,
    removedDocuments,
    setRemovedDocuments,
    tema: temaSindico,
  } = useContext(isSindico ? ContextSindico : ContextSolicitacoes);

  const tema = isSindico ? temaSindico : temaPortal;

  const respostaRef = useRef(null);
  const [editarSolicitacao, setEditarSolicitacao] = useState(false);

  const [showCancelarSolicitacao, setShowCancelarSolicitacao] = useState(false);

  const [apontamentoSelecionado, setApontamentoSelecionado] = useState(
    'Selecione uma categoria de apontamento que melhor descreva o seu reparo.'
  );
  const [solicitacaoParaAcompanhar, setSolicitacaoParaAcompanhar] =
    useState('');

  const [salvarAlteracoes, setSalvarAlteracoes] = useState(false);

  const [loadingSolicitacao, setLoadingSolicitacao] = useState(true);

  const params = useParams();

  const solicitacaoId = params.id;

  const addUUID = () => {
    return solicitacaoParaAcompanhar?.workOrder?.map((reparo) => ({
      ...reparo,
      documents:
        solicitacaoParaAcompanhar?.anexos?.length > 0
          ? solicitacaoParaAcompanhar?.anexos?.find(
              (item) => item.descricao === reparo.workTypeId
            )?.documentosS3
          : reparo.documents?.length > 0
          ? reparo.documents
          : [],
      idSelecaoReparo: uuid(),
    }));
  };

  const [reparos, setReparos] = useState(addUUID());

  const reparosOriginais = addUUID();

  const refCancelamento = useRef(null);

  const [entendiConcordo, setEntendiConcordo] = useState(false);

  const [savingChanges, setSavingChanges] = useState(false);

  const [showAddReparoPopup, setShowAddReparoPopup] = useState(false);

  const handleCancelEdit = () => {
    setReparos(reparosOriginais);
    setRemovedDocuments([]); // limpa o array de documentos a serem removidos
    setApontamentoSelecionado(
      'Selecione uma categoria de apontamento que melhor descreva o seu reparo.'
    );
    setEditarSolicitacao(false);
    setSalvarAlteracoes(false);
  };

  const handleSaveChanges = async () => {
    setSavingChanges(true);
    const apontamentosAntigos = objReparos(reparosOriginais);
    const apontamentosNovos = objReparos(reparos);

    await editAssistenciaTecnica({
      apontamentosAntigos,
      apontamentosNovos,
    });

    if (removedDocuments?.length > 0) {
      await removeFiles(removedDocuments, solicitacaoParaAcompanhar?.id);
      setRemovedDocuments([]);
    }

    await saveFiles(reparos, solicitacaoParaAcompanhar?.id);

    setRemovedDocuments([]);

    await getSolicitacaoParaAcompanhar(solicitacaoParaAcompanhar.id);
  };
  const objReparos = (arrayReparos) => {
    return arrayReparos.map((reparo) => ({
      workOrderId: solicitacaoParaAcompanhar.workOrderId,
      idWorkOrderLineItem: reparo.id || undefined,
      workTypeId: reparo.workTypeId,
      description: reparo.description,
      documents: reparo.documents,
    }));
  };

  const handleAnexos = async (solicitacao) => {
    let anexos = solicitacao?.anexos;
    if (!anexos) {
      anexos = await getAnexoSolicitacao(solicitacao);
    } else {
      const { data: url } = await getUrlFotoS3(solicitacao.anexos.idAws);
      anexos = [{ ...anexos, url, nomeArquivo: 'anexo.pdf' }];
    }

    return anexos;
  };

  const getSolicitacaoParaAcompanhar = async (id) => {
    if (!loadingSolicitacao) setLoadingSolicitacao(true);
    let responseSolicitacao = await getSolicitacao(id);

    let anexos = await handleAnexos(responseSolicitacao);

    setSolicitacaoParaAcompanhar({ ...responseSolicitacao, anexos });
    setSavingChanges(false);
    setLoadingSolicitacao(false);
    setEntendiConcordo(false);
  };

  useEffect(() => {
    (async function () {
      if (confirmarSolicitacao) setSolicitacaoParaAcompanhar(solicitacao);
      else await getSolicitacaoParaAcompanhar(solicitacaoId);
    })();
  }, []);

  useEffect(() => {
    setReparos(addUUID());
  }, [solicitacaoParaAcompanhar]);

  const refEditarSolicitacao = useRef(null);

  const executeScroll = () => refEditarSolicitacao?.current?.scrollIntoView();

  if (!solicitacaoParaAcompanhar)
    return (
      <div style={{ width: '100%', margin: '24px 0' }} className='centralized'>
        <Spinner />
      </div>
    );

  return (
    <div ref={refCancelamento}>
      {!isSindico && (
        <HeaderStroke name={'Solicitações'} msgDadosCadastrais={false} />
      )}
      {confirmarSolicitacao && (
        <Title color={tema.primaryColor}>Resumo da solicitação:</Title>
      )}

      {!isSindico &&
        solicitacaoParaAcompanhar?.tipo === 'Assistência Técnica' &&
        solicitacaoParaAcompanhar?.fase !== 'Concluído' && (
          <MsgAvisoAssistenciaTecnica>
            <span className='title-messageAT'>Atenção!</span>
            <p className='messageAT'>
              Prezado(a) cliente, ative as notificações do seu celular para
              receber o aviso de quando o técnico estiver a caminho da sua
              unidade.
            </p>
          </MsgAvisoAssistenciaTecnica>
        )}
      <MsgSolicitacao
        tema={tema}
        respostaRef={respostaRef}
        solicitacaoRespondida={solicitacaoParaAcompanhar?.emailResponse}
        statusSolicitacao={solicitacaoParaAcompanhar?.status}
        isSindico={isSindico}
      />
      <div ref={refEditarSolicitacao}>
        <DadosSolicitacao
          solicitacao={solicitacaoParaAcompanhar}
          editarSolicitacao={editarSolicitacao}
          tema={tema}
          respostaRef={respostaRef}
          confirmarSolicitacao={confirmarSolicitacao}
          tiposSolicitacaoComAgendamento={tiposSolicitacaoComAgendamento}
          isSindico={isSindico}
        />
      </div>
      {editarSolicitacao && (
        <EditarSolicitacao
          tema={tema}
          editarSolicitacao={editarSolicitacao}
          reparosOriginais={reparosOriginais}
          reparos={reparos}
          setReparos={setReparos}
          apontamentoSelecionado={apontamentoSelecionado}
          setApontamentoSelecionado={setApontamentoSelecionado}
          setSalvarAlteracoes={setSalvarAlteracoes}
          salvarAlteracoes={salvarAlteracoes}
          refEditarSolicitacao={refEditarSolicitacao}
          isSindico={isSindico}
          savingChanges={savingChanges}
          showAddReparoPopup={showAddReparoPopup}
          setShowAddReparoPopup={setShowAddReparoPopup}
          setEntendiConcordo={setEntendiConcordo}
          entendiConcordo={entendiConcordo}
        >
          {solicitacaoParaAcompanhar?.workOrder &&
            reparos?.length > 0 &&
            solicitacaoParaAcompanhar.tipo === 'Assistência Técnica' && (
              <ResumoAgendamento
                reparos={reparos}
                tema={tema}
                anexos={solicitacaoParaAcompanhar?.anexos}
                // handleRemoveReparo={handleRemoveReparo}
                acompanharSolicitacao
                editarSolicitacao={editarSolicitacao}
                setReparos={setReparos}
                setSalvarAlteracoes={setSalvarAlteracoes}
                confirmarSolicitacao={confirmarSolicitacao}
                savingChanges={savingChanges}
                isSindico={isSindico}
              />
            )}
        </EditarSolicitacao>
      )}
      {!editarSolicitacao &&
        solicitacaoParaAcompanhar?.workOrder &&
        reparos?.length > 0 &&
        solicitacaoParaAcompanhar.tipo === 'Assistência Técnica' && (
          <ResumoAgendamento
            reparos={reparos}
            tema={tema}
            anexos={solicitacaoParaAcompanhar?.anexos}
            acompanharSolicitacao
            editarSolicitacao={editarSolicitacao}
            setReparos={setReparos}
            setSalvarAlteracoes={setSalvarAlteracoes}
            confirmarSolicitacao={confirmarSolicitacao}
            savingChanges={savingChanges}
            isSindico-={isSindico}
          />
        )}
      {editarSolicitacao && salvarAlteracoes && !showAddReparoPopup && (
        <EntendiConcordo
          setEntendiConcordo={setEntendiConcordo}
          entendiConcordo={entendiConcordo}
          imovel={solicitacaoParaAcompanhar.assetId}
          savingChanges={savingChanges}
          isSindico={isSindico}
        />
      )}
      {showCancelarSolicitacao && (
        <CancelarSolicitacao
          showCancelarSolicitacao={showCancelarSolicitacao}
          setShowCancelarSolicitacao={setShowCancelarSolicitacao}
          caseNumber={solicitacaoParaAcompanhar?.caseNumber}
          compromissoServico={solicitacaoParaAcompanhar?.compromissoServico}
          subgrupo={solicitacaoParaAcompanhar?.subgrupo}
          solicitacaoId={solicitacaoParaAcompanhar?.id}
          isSindico={isSindico}
        />
      )}
      {!confirmarSolicitacao && !showCancelarSolicitacao && (
        <Buttons
          setEditarSolicitacao={setEditarSolicitacao}
          tema={tema}
          dataAgendamento={
            solicitacaoParaAcompanhar?.compromissoServico?.earliestStartTime
          }
          origemSolicitacao={solicitacaoParaAcompanhar.origin}
          statusSolicitacao={solicitacaoParaAcompanhar.status}
          editarSolicitacao={editarSolicitacao}
          setShowCancelarSolicitacao={setShowCancelarSolicitacao}
          handleCancelEdit={handleCancelEdit}
          setApontamentoSelecionado={setApontamentoSelecionado}
          subgrupo={solicitacaoParaAcompanhar?.subgrupo}
          salvarAlteracoes={salvarAlteracoes}
          setSalvarAlteracoes={setSalvarAlteracoes}
          handleSaveChanges={handleSaveChanges}
          entendiConcordo={entendiConcordo}
          executeScroll={executeScroll}
          savingChanges={savingChanges}
        />
      )}
    </div>
  );
};

export default AcompanharSolicitacao;

AcompanharSolicitacao.propTypes = {
  solicitacao: PropTypes.object,
};
